import type { EntityListData, EntityListOptions } from "~/types";
import { formatPropertyOptions } from "./handlers/getPropertyEntityList";
import { formatBuildingOptions } from "./handlers/getBuildingEntityList";
import { formatUnitOptions } from "./handlers/getUnitEntityList";
import { formatServiceRequestOptions } from "./handlers/getServiceRequestEntityList";
import { formatAmenityOptions } from "./handlers/getAmenityEntityList";
import { formatUnitPlanOptions } from "./handlers/getUnitPlanEntityList";
import { formatParcelOptions } from "./handlers/getParcelEntityList";

export const getEntityListOptions = (
  data: EntityListData | undefined
): EntityListOptions[] => {
  if (!data) return [];

  // Prefer the most specific non-empty list. Unit dropdowns ship propertyMap for
  // labels but must not treat a populated propertyList as the option source.
  if (data.unitList?.length > 0) {
    return formatUnitOptions(data.unitList, data.propertyMap, data.buildingMap);
  }

  // Handle Property list
  if (data.propertyList?.length > 0) {
    return formatPropertyOptions(data.propertyList);
  }

  // Handle Building list
  if (data.buildingList?.length > 0) {
    return formatBuildingOptions(data.buildingList, data.propertyMap);
  }

  // Handle Service Request list
  if (data.serviceRequestList?.length > 0) {
    return formatServiceRequestOptions(
      data.serviceRequestList,
      data.propertyMap,
      data.unitMap,
      data.buildingMap,
      data.parcelMap
    );
  }

  // Handle Amenity list
  if (data.amenityList?.length > 0) {
    return formatAmenityOptions(data.amenityList, data.propertyMap);
  }

  if (data.unitPlanList?.length) {
    return formatUnitPlanOptions(data.unitPlanList, data.propertyMap);
  }

  if (data.parcelList?.length) {
    return formatParcelOptions(data.parcelList, data.propertyMap);
  }

  return [];
};
